import { Slide } from "@jelly/lesson";

import { task as task03 } from "../../../../../task/course-04/lesson-28/task-03";

const task: Slide = {
  titleHtml:
    "Which directivity pattern corresponds to that of a linear array<br>of 10 loudspeakers separated by 40 cm for a frequency of 1000 Hz?",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task03.id,
        },
      },
    },
  },
};

export default task;
